module.exports = __webpack_public_path__ + "img/9788952780447.17044f59.jpg";